var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_container",attrs:{"id":'chart-'+_vm.index},on:{"click":_vm.processClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }